import { getAllThemesWithCounts } from '../data';
import { getTopicsSearchIndex } from '../search';
import ThematicStudiesSearch from '../components/ThematicStudiesSearch';

export default function ThematicStudiesIndexPage() {
    const searchIndex = getTopicsSearchIndex();
    const themesWithCounts = getAllThemesWithCounts();

    return <ThematicStudiesSearch searchIndex={searchIndex} themesWithCounts={themesWithCounts} />;
}
